<template>
<section :class="[block.class, {'half-padding-top': block.half_padding_top}, {'half-padding-bottom': block.half_padding_bottom}, 'section', block.bgcolour]" :id="block.anchor ? block.anchor : ('block-' + block.id)">
    <div class="container">
        <h2 v-if="!block.hide_title" :class="['title', block.title_colour]">{{block.title}}</h2>
        <div class="columns is-variable is-6" v-if="block.items && block.items.length > 0" v-for="item in block.items">
            <div class="column is-4">
                <h3 v-if="item.title" :class="['title', block.title_colour]">{{item.title}}</h3>
            </div>
            <div class="column is-6">
                <div class="content" ref="content" v-if="item.content" v-html="item.content"></div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import BlockCommons from '../../mixins/BlockCommons';

export default {
    name        :   'RepeatableContentBlock',
    mixins      :   [ BlockCommons ],
    mounted() {
        this.$nextTick().then(() => {
            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
        })
    },
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/RepeatableContentBlock.vue